// Translation: Password change > Landing > Form (Turkish)
export default Object.freeze({
	form: {
		actions: {
			changePassword: 'Şifreyi değiştir'
		},
		fields: {
			oldPassword: {
				placeholder: 'Eski şifrenizi girin'
			},
			password: {
				placeholder: 'Yeni şifrenizi ayarlayın'
			},
			passwordConfirmation: {
				placeholder: 'Yeni şifrenizi onaylayın'
			}
		},
		title: 'Şifre değiştirme'
	}
})
